import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export interface AdminKit {
  id: string;
  name: string;
  kitType: "basic" | "advanced" | "premium" | string;
  deviceBrand?: string;
  deviceModel?: string;
  macAddress?: string;
  serialNumber?: string;
  status: "pending" | "active" | "disabled" | "maintenance" | string;
  kycStatus: string;
  paymentStatus: string;
  amountPaid?: number;
  activationDate?: string | null;
  registrationSource?: string;
  operator?: { id: string; name: string; email: string } | null;
  createdAt?: string;
}

export interface AdminKitCounts {
  total: number; pending: number; active: number; disabled: number; maintenance: number;
}

export const getAdminKits = async (status?: string): Promise<{ kits: AdminKit[]; counts: AdminKitCounts }> => {
  const q = status && status !== "all" ? `?status=${encodeURIComponent(status)}` : "";
  const res = await apiClient.get<{ success: boolean; counts: AdminKitCounts; kits: AdminKit[] }>(
    ENDPOINTS.ADMIN.KITS + q
  );
  return { kits: res.data?.kits || [], counts: res.data?.counts || { total: 0, pending: 0, active: 0, disabled: 0, maintenance: 0 } };
};

export const approveAdminKit = async (id: string): Promise<{ success: boolean; message?: string }> => {
  const res = await apiClient.patch<{ success: boolean; message?: string }>(ENDPOINTS.ADMIN.KIT_APPROVE(id), {});
  return res.data;
};

export const rejectAdminKit = async (id: string): Promise<{ success: boolean; message?: string }> => {
  const res = await apiClient.patch<{ success: boolean; message?: string }>(ENDPOINTS.ADMIN.KIT_REJECT(id), {});
  return res.data;
};
